var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-arrow-down';
                    var viewUrl = 'sprite.svg#view-icon-arrow-down';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 7',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };